import React from 'react';
import Carousel from '../components/Carousel';
import NavMenu from '../components/NavMenu';
import IconNav from '../components/IconNav';
import LiveCard from '../components/LiveCard';
import ClassCard from '../components/ClassCard';
import ClassCardTwo from '../components/ClassCardTwo';



// 模块类型
export const MODULES_MAP = {
  1: {
    name: "轮播图",
    key: "carousel",
    template: Carousel,
  },
  2: {
    name: "ICON导航",
    key: "icon-nav",
    template: IconNav,
  },
  3: {
    name: "课程模块-单排",
    key: "classcard-one",
    template: ClassCard,
  },
  4: {
    name: "课程模块-双排",
    key: "classcard-two",
    template: ClassCardTwo
  }
}

// 根据modules信息生成html
export const generateHTMLByModule = (mod, config = {}) => {
  const m = mod.module;
  const data = mod.data;
  const type = m.type;
  const template = MODULES_MAP[type]['template'];

  if (data.length === 0) {
    return null;
  }

  return (
    <div className={config.className || ""} key={config.key || MODULES_MAP[type]['key']}>
      {
        template({ data, mod: m })
      }
    </div>
  )
}
